import { render, staticRenderFns } from "./PublicRelation.vue?vue&type=template&id=217894e2&scoped=true"
import script from "./PublicRelation.vue?vue&type=script&lang=js"
export * from "./PublicRelation.vue?vue&type=script&lang=js"
import style0 from "./PublicRelation.vue?vue&type=style&index=0&id=217894e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217894e2",
  null
  
)

export default component.exports